import { render, staticRenderFns } from "./AppSimple.vue?vue&type=template&id=1fcb20ca"
import script from "./AppSimple.vue?vue&type=script&lang=ts"
export * from "./AppSimple.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports